import React, { useRef, useEffect } from 'react';
import {
  Row,
  Form,
  Input,
  Col,
  Switch,
  Select,
  Alert,
  Button,
  Divider,
  Tooltip
} from 'antd';
import { notifyNotEditable } from './notifyNotEditable';
import ReactQuill from 'react-quill';
import { createGlobalStyle } from 'styled-components';
import { DeleteConfirmationMessage } from '../Dictation/styledComponents.js';
import Spinner from '../../CustomComponents/Spinner';
import {
  StyledTag,
  StyledTagContainer,
  StyledTree,
  Keytophraseduplication,
  RestrictColumImport,
  IconWrapper,
  TextWrapper
} from './styledComponents.js';
import { useState } from 'react';
import DragIndicatorIcon from '../../../Assets/Icons/DragIndicatorIcon.js';
import ConfirmationModal from '../../CustomComponents/ConfirmationModal';
import CustomTypography from '../../CustomComponents/CustomTypography/index.jsx';
import { useSelector } from 'react-redux';
import { DownOutlined } from '@ant-design/icons';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.snow.css'; // Add css for snow theme

// --- Dynamic variable pill blot ---
const QuillLib = ReactQuill.Quill;
const Embed = QuillLib.import('blots/embed');

class DynamicVariableBlot extends Embed {
  static create(value) {
    const node = super.create();
    node.setAttribute('data-value', value);
    node.setAttribute('contenteditable', 'false');

    const text = document.createElement('span');
    text.className = 'dv-pill-text';
    text.textContent = value;

    const removeBtn = document.createElement('span');
    removeBtn.className = 'dv-pill-remove';
    removeBtn.textContent = '×';

    node.appendChild(text);
    node.appendChild(removeBtn);
    return node;
  }

  static value(node) {
    return node.getAttribute('data-value');
  }
}
DynamicVariableBlot.blotName = 'dynamic-variable';
DynamicVariableBlot.tagName = 'span';
DynamicVariableBlot.className = 'dv-pill';
QuillLib.register(DynamicVariableBlot);

const DvPillStyles = createGlobalStyle`
  .ql-editor .dv-pill {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 1px 8px 1px 10px;
    background: #e6f7ff;
    color: #1d7ec2;
    border: 1px solid #91d5ff;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    cursor: default;
    user-select: none;
    margin: 0 2px;
    vertical-align: middle;
    line-height: 1.6;
  }
  .ql-editor .dv-pill-text {
    pointer-events: none;
  }
  .ql-editor .dv-pill-remove {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    cursor: pointer;
    color: #1d7ec2;
    font-size: 13px;
    line-height: 1;
    opacity: 0.6;
    flex-shrink: 0;
  }
  .ql-editor .dv-pill-remove:hover {
    opacity: 1;
    background: #91d5ff;
  }
`;
const wrapVariablesAsPills = html => {
  if (!html) return html;
  return html.replace(/\$\{([^}]+)\}/g, match =>
    `<span class="dv-pill" data-value="${match}"></span>`
  );
};
// --- end pill blot ---

const AddKeyToPhraseForm = ({
  form,
  activeEnable,
  setActiveEnable,
  handleCheck,
  selectedItem,
  setSubmitDisabled,
  selectedItemColumn,
  handleDeleteClick,
  toggleTreeVisibility,
  submitHandler,
  treeVisible,
  loadingTree,
  submitLoading,
  dynamicEndPoints,
  handleActiveClickChange,
  showTable,
  selectedPhrase,
  k2pMapping,
  toggleActive,
  toActive,
  submitDisabled,
  handleFormValuesChange,
  handleMineDelete,
  selectedFields,
  deleteModal,
  updatedK2pMappingkeys,
  handleActivateToggleSave,
  templateMappingModified
}) => {
  const [theme] = useSelector(state => [state.themeReducer]);

  const [dynamicEnable, setDynamicEnable] = useState(
    selectedItem ? selectedItem.dynamic : false
  );
  const [expandedFields, setExpandedFields] = useState(['']);
  const [globallyEnable, setGloballyEnable] = useState(
    selectedItem ? selectedItem.global : false
  );
  const user = useSelector(state => state.userReducer);
  const handleModalOk = () => {
    toggleActive();
  };
  const [exportToOtherAuthors, setExportToOtherAuthors] = useState(
    selectedItem ? selectedItem.exportToOtherAuthors : false
  );
  // The Key, Phrase and Default Value fields are read-only for non-editable
  // Key-to-Phrases; clicking them informs the user why they can't be changed.
  const handleNonEditableFieldClick = () => {
    if (selectedItem && !selectedItem.editable) {
      notifyNotEditable();
    }
  };
  const k2pMappingTreeData = k2pMapping.map(template => {
    return {
      title: template.templateName,

      selected: template.selected,
      key: template.id,
      children: template.sectionHeadings.map(heading => {
        return {
          title: heading.customUIHeading,
          selected: heading.selected,

          key: `${template.id}-${heading.customUIHeading}`
        };
      })
    };
  });

  const [selectedDynamicEndPoint, setSelectedDynamicEndPoint] = useState(() => {
    if (selectedItem) {
      return selectedItem.targetEndPoint;
    } else if (dynamicEndPoints && dynamicEndPoints.length > 0) {
      return dynamicEndPoints[0].fieldUiValue;
    } else {
      return '';
    }
  });
  // const phaseTextAreaRef = useRef(null);
  const quillRef = useRef(null);
  const isVisible =
    user.userType === 'admin' || user.userType === 'clinicAdmin';
  const CustomLabelApplyToAll = () => (
    <div>
      <p
        style={{
          height: '18px',
          fontWeight: 600,
          fontSize: '14px',
          lineHeight: '18.2px',
          color: '#2B2B2B'
        }}
      >
        Apply to all users
      </p>
    </div>
  );

  const CustomLabelActivate = () => (
    <div>
      <p
        style={{
          height: '18px',
          fontWeight: 600,
          fontSize: '14px',
          lineHeight: '18.2px',
          color: '#2B2B2B'
        }}
      >
        Activate
      </p>

      <p
        style={{
          fontSize: '12px',
          lineHeight: '15.6px',
          color: '#5C5C5C'
        }}
      >
        Toggle to activate or deactivate this Key-to-phrase.
      </p>
    </div>
  );

  const CustomLabel = () => (
    <div>
      <p
        style={{
          height: '18px',
          fontWeight: 600,
          fontSize: '14px',
          lineHeight: '18.2px',
          color: '#2B2B2B'
        }}
      >
        Globally Available
      </p>

      <p
        style={{
          fontSize: '12px',
          lineHeight: '15.6px',
          color: '#5C5C5C'
        }}
      >
        Making it globally available will enable all users in the clinic to use
        this Key-to-phrase.
      </p>
    </div>
  );

  const CustomLabel2 = () => (
    <div>
      <p
        style={{
          height: '18px',
          fontWeight: 600,
          fontSize: '14px',
          lineHeight: '18.2px',
          color: '#2B2B2B'
        }}
      >
        Restrict to selected Templates
      </p>

      <p
        style={{
          fontSize: '12px',
          lineHeight: '15.6px',
          color: '#5C5C5C'
        }}
      >
        Key-to-Phrase will be triggered only on these selected templates and
        heading inside them.
      </p>
    </div>
  );
  const [endpointChangeModalVisible, setEndpointChangeModalVisible] =
    useState(false);

  const handleEndPointChange = value => {
    const regex = /(\$\{(.*?)\})/g;
    if (
      selectedDynamicEndPoint !== value &&
      form.getFieldValue('phrase')?.match(regex)?.length > 0
    ) {
      setEndpointChangeModalVisible(true);
    } else {
      setSelectedDynamicEndPoint(value);
    }
  };
  const onExpand = (expandedKeys, expanded) => {
    setExpandedFields(expandedKeys);
  };
  const handleEndPointChangeConfirm = () => {
    const phraseData = form.getFieldValue('phrase');
    const data = form.getFieldsValue();
    form.setFieldsValue({
      ...data,
      phrase: phraseData.replace(/(\$\{(.*?)\})/g, '')
    });
    setSelectedDynamicEndPoint(form.getFieldValue('targetEndPoint'));
    setEndpointChangeModalVisible(false);
  };

  const handleEndPointChangeCancel = () => {
    const data = form.getFieldsValue();
    form.setFieldsValue({
      ...data,
      targetEndPoint: selectedDynamicEndPoint
    });
    setEndpointChangeModalVisible(false);
  };

  const dropHandler = e => {
    e.preventDefault();
    const data = e.dataTransfer.getData('text/html');
    if (!data) return;
    const quill = quillRef.current.getEditor();
    quill.focus();
    const range = quill.getSelection() || { index: Math.max(0, quill.getLength() - 1) };
    quill.insertEmbed(range.index, 'dynamic-variable', data, 'user');
    quill.setSelection(range.index + 1, 0, 'user');
  };
  const dragStartHandler = e => {
    e.dataTransfer.setData('text/html', '${' + e.target.textContent + '}');
  };
  const dynamicStyle = !dynamicEnable
    ? { height: '360px' }
    : { width: '320px' };

  const modules = {
    toolbar: [['bold', 'italic', 'underline', 'strike', 'clean']],
    clipboard: {
      matchVisual: false
    }
  };
  const removeHTMLTags = str => {
    return str.replace(/<[^>]*>?/gm, '');
  };
  useEffect(() => {}, [form, dynamicEnable]); // Add dependencies to ensure useEffect triggers when form or dynamicEnable changes
  const onSelect = (selectedKeys, info) => {};

  const onCheck = (checkedKeys, info) => {};

  return (
    <>
      <DvPillStyles />
      <Form
        form={form}
        layout='vertical'
        onFinish={values => {
          const tmp = document.createElement('div');
          tmp.innerHTML = values.phrase || '';
          tmp.querySelectorAll('.dv-pill').forEach(pill => {
            const value = pill.getAttribute('data-value') || '';
            pill.replaceWith(document.createTextNode(value));
          });
          submitHandler({ ...values, phrase: tmp.innerHTML });
        }}
        onValuesChange={handleFormValuesChange}
        initialValues={{
          key: selectedItem ? selectedItem.key : '',
          global: selectedItem ? selectedItem.global : false,
          restrictedToTemplates: selectedItem
            ? selectedItem.restrictedToTemplates
            : false,
          active: selectedItem ? selectedItem.active : true,
          dynamic: selectedItem ? selectedItem.dynamic : false,
          templateMapping: updatedK2pMappingkeys,
          targetEndPoint:
            selectedItem && selectedItem.targetEndPoint
              ? selectedItem.targetEndPoint
              : selectedDynamicEndPoint,
          phrase: selectedItem ? wrapVariablesAsPills(selectedItem.phrase) : '',
          defaultValue: selectedItem ? selectedItem.defaultValue || '' : '',
          exportToOtherAuthors: selectedItem
            ? selectedItem.exportToOtherAuthors ?? false
            : false
        }}
      >
        <Row gutter={24}>
          <Col span={14}>
            <Row justify={'center'}>
              <Col span={24}>
                <Row>
                  <Col span={24}>
                    <Form.Item
                      label='Key'
                      name='key'
                      rules={[{ required: true, message: 'Key is required' }]}
                    >
                      <Input
                        size='large'
                        onDrop={event => {
                          event.preventDefault();
                        }}
                        onClick={handleNonEditableFieldClick}
                        readOnly={
                          !(selectedItem ? selectedItem.editable : true)
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  gutter={16}
                  className='DynamicRow'
                  align={'middle'}
                  style={{ marginBottom: '16px' }}
                >
                  <Col span={4}>
                    <label
                      style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#2B2B2B'
                      }}
                    >
                      Phrase
                    </label>
                  </Col>
                  <Col span={2}>
                    <span
                      style={{
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#2B2B2B',
                        display: 'inline-block',
                        verticalAlign: 'middle'
                      }}
                    >
                      Type
                    </span>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      name='dynamic'
                      style={{ marginBottom: 0, marginRight: 'auto' }}
                    >
                      <Switch
                        checked={dynamicEnable}
                        checkedChildren='Dynamic'
                        unCheckedChildren='Static'
                        onChange={() => {
                          form.setFieldValue({
                            ...form.getFieldsValue(),
                            dynamic: !dynamicEnable
                          });
                          setDynamicEnable(!dynamicEnable);
                        }}
                        disabled={
                          !(selectedItem ? selectedItem.editable : true)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <span
                      style={{
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#2B2B2B',
                        display: 'inline-block',
                        verticalAlign: 'middle'
                      }}
                    >
                      Category:
                    </span>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      name='targetEndPoint'
                      style={{
                        marginBottom: 0,
                        marginRight: 'auto'
                      }}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Dynamic Category is required'
                      //   }
                      // ]}
                    >
                      <Select
                        placeholder={'Please select Dynamic Category'}
                        disabled={!dynamicEnable}
                        onChange={handleEndPointChange}
                        style={{ borderRadius: '8px' }}
                      >
                        {dynamicEndPoints &&
                          dynamicEndPoints.map(endPoint => (
                            <Select.Option
                              key={endPoint.fieldUiValue}
                              value={endPoint.fieldUiValue}
                            >
                              {endPoint.fieldUiName}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col span={24}>
                    <Row justify={'space-between'}>
                      <Col span={dynamicEnable ? 10 : 24}>
                        <div
                          id='quilldiv'
                          onClick={e => {
                            if (e.target.classList.contains('dv-pill-remove')) {
                              e.preventDefault();
                              e.stopPropagation();
                              const pill = e.target.closest('.dv-pill');
                              if (pill) {
                                const quill = quillRef.current.getEditor();
                                const blot = QuillLib.find(pill);
                                if (blot) {
                                  const index = quill.getIndex(blot);
                                  quill.deleteText(index, 1, 'user');
                                }
                              }
                              return;
                            }
                            handleNonEditableFieldClick(e);
                          }}
                          onDrop={dropHandler}
                          onDragOver={e => e.preventDefault()}
                          style={{ marginBottom: '16px' }}
                        >
                          <Form.Item
                            // label='Phrase'
                            name='phrase'
                            style={{ marginBottom: 0 }}
                            rules={[
                              { required: true, message: 'Phrase is required' }
                            ]}
                          >
                            <ReactQuill
                              style={dynamicStyle}
                              className={dynamicEnable ? 'k2p-dynamic-phrase' : undefined}
                              modules={modules}
                              ref={quillRef}
                              theme='snow'
                              readOnly={
                                !(selectedItem ? selectedItem.editable : true)
                              }
                            />
                          </Form.Item>
                        </div>
                        {dynamicEnable && (
                          <Form.Item
                            name='defaultValue'
                            label='Default Value'
                            style={{
                              marginTop: '12px',
                              marginBottom: 0,
                              width: '320px'
                            }}
                          >
                            <Input
                              onChange={() => setSubmitDisabled(true)}
                              placeholder='Enter default value'
                              onClick={handleNonEditableFieldClick}
                              readOnly={
                                !(selectedItem ? selectedItem.editable : true)
                              }
                            />
                          </Form.Item>
                        )}
                      </Col>
                      {dynamicEnable ? (
                        <>
                          <Col span={8}>
                            <StyledTagContainer>
                              {dynamicEndPoints &&
                                dynamicEndPoints
                                  .find(
                                    endpoint =>
                                      endpoint.fieldUiValue ===
                                      selectedDynamicEndPoint
                                  )
                                  ?.avilableFields.map(dynamicFields => {
                                    return (
                                      // <StyledTag
                                      //   key={dynamicFields}
                                      //   draggable='true'
                                      //   onDragStart={dragStartHandler}
                                      // >
                                      //   <DragIndicatorIcon color={'#000000'} />
                                      //   {dynamicFields}
                                      // </StyledTag>
                                      <StyledTag
                                        key={dynamicFields}
                                        draggable
                                        onDragStart={dragStartHandler}
                                      >
                                        <IconWrapper>
                                          <DragIndicatorIcon color='#000000' />
                                        </IconWrapper>
                                        <Tooltip
                                          title={dynamicFields}
                                          placement='topLeft'
                                        >
                                          <TextWrapper>
                                            {dynamicFields}
                                          </TextWrapper>
                                        </Tooltip>
                                      </StyledTag>
                                    );
                                  })}
                            </StyledTagContainer>
                          </Col>
                        </>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>

          <RestrictColumImport span={10}>
            <div className='configurationHead' style={{ marginBottom: '12px' }}>
              Configuration
            </div>
            <div
              className='RestrictColum'
              style={{
                backgroundColor: '#F5F7FA',
                padding: '10px 20px',
                borderRadius: '8px',
                marginBottom: '15px'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '12px'
                }}
              >
                <CustomLabelActivate />
                <Form.Item name='active' style={{ marginBottom: 0 }}>
                  <Switch
                    checked={activeEnable}
                    onChange={() => {
                      const newValue = !activeEnable;
                      if (selectedItem) {
                        setSubmitDisabled(newValue !== !!selectedItem.active);
                      } else {
                        setSubmitDisabled(true);
                      }
                      form.setFieldsValue({
                        ...form.getFieldsValue(),
                        active: newValue
                      });
                      setActiveEnable(newValue);
                    }}
                  />
                </Form.Item>
              </div>
            </div>
            <div
              className='RestrictColum'
              style={{
                backgroundColor: '#F5F7FA',
                padding: '20px',
                borderRadius: '8px',
                marginBottom: '15px'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '12px'
                }}
              >
                <CustomLabel />
                <Form.Item name='global' style={{ marginBottom: 0 }}>
                  <Switch
                    checked={globallyEnable}
                    onChange={() => {
                      form.setFieldValue({
                        ...form.getFieldsValue(),
                        global: !globallyEnable
                      });
                      setGloballyEnable(!globallyEnable);
                    }}
                    disabled={!(selectedItem ? selectedItem.editable : true)}
                  />
                </Form.Item>
              </div>
            </div>

            <div
              className='RestrictColum'
              style={{
                backgroundColor: '#F5F7FA',
                padding: '20px',
                borderRadius: '8px',
                maxHeight: '270px',
                overflow: 'scroll'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '12px'
                }}
              >
                <CustomLabel2 />
                <Form.Item
                  name='restrictedToTemplates'
                  style={{ marginBottom: 0 }}
                >
                  <Switch
                    checked={treeVisible}
                    onChange={newValue => {
                      if (selectedItem) {
                        setSubmitDisabled(
                          newValue !== !!selectedItem.restrictedToTemplates
                        );
                      } else {
                        setSubmitDisabled(true);
                      }
                      toggleTreeVisibility(newValue);
                    }}
                  />
                </Form.Item>
              </div>
              {loadingTree ? (
                <Spinner height={'3vh'} />
              ) : (
                treeVisible && (
                  <Form.Item
                    name='templateMapping'
                    style={{ marginBottom: 0, marginTop: '8px' }}
                  >
                    <StyledTree
                      checkable
                      selectable={false}
                      onCheck={handleCheck}
                      switcherIcon={<DownOutlined />}
                      autoExpandParent
                      expandedKeys={[...expandedFields]}
                      onExpand={onExpand}
                      checkedKeys={selectedFields.map(selectedField => {
                        return selectedField.id;
                      })}
                      treeData={k2pMapping?.map(item => {
                        return {
                          title: item.templateName,
                          key: item.id,

                          children: item?.sectionHeadings?.map(subItem => {
                            return {
                              title: subItem.customUIHeading,
                              key: subItem.id,
                              switcherIcon: <span className='dot-switcher' />
                            };
                          })
                        };
                      })}
                    />
                  </Form.Item>
                )
              )}
            </div>
            {isVisible && (selectedItem ? selectedItem.editable : true) && (
              <div
                className='RestrictColum'
                style={{
                  backgroundColor: '#F5F7FA',
                  padding: '20px',
                  borderRadius: '8px',
                  marginTop: '15px'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '12px'
                  }}
                >
                  <CustomLabelApplyToAll />
                  <Form.Item
                    name='exportToOtherAuthors'
                    style={{ marginBottom: 0 }}
                  >
                    <Switch
                      checked={exportToOtherAuthors}
                      onChange={() => {
                        const newValue = !exportToOtherAuthors;
                        if (selectedItem) {
                          setSubmitDisabled(
                            newValue !== !!selectedItem.exportToOtherAuthors
                          );
                        } else {
                          setSubmitDisabled(true);
                        }
                        form.setFieldsValue({
                          ...form.getFieldsValue(),
                          exportToOtherAuthors: newValue
                        });
                        setExportToOtherAuthors(newValue);
                      }}
                    />
                  </Form.Item>
                </div>
              </div>
            )}
          </RestrictColumImport>

        </Row>
      </Form>
      <ConfirmationModal
        antdModalProps={{ centered: true, width: '500', closable: false }}
        visible={endpointChangeModalVisible}
        onCancel={handleEndPointChangeCancel}
        onOk={handleEndPointChangeConfirm}
        header={
          <CustomTypography color={theme['@text-color']}>
            Are you sure?
          </CustomTypography>
        }
        confirmation={true}
        buttonAlignCenter={true}
      >
        <h1>{`Do you really want to change Dynamic Category ?`}</h1>
        <Alert
          message={<b>Warning</b>}
          description='The tags associated with phrase will be removed.'
          type='warning'
          showIcon
          closable={false}
        />
      </ConfirmationModal>

      <Keytophraseduplication
        title='Save Changes'
        visible={submitDisabled && toActive}
        onCancel={toggleActive}
        footer={[
          <Button key='save' type='primary' onClick={handleModalOk}>
            Ok
          </Button> // Button to save changes
        ]}
      >
        <DeleteConfirmationMessage>
          Please save the changes to proceed?
        </DeleteConfirmationMessage>
      </Keytophraseduplication>
      <ConfirmationModal
        visible={deleteModal}
        onOk={() => handleDeleteClick(exportToOtherAuthors)}
        onCancel={toggleActive}
        centered
        confirmation={true}
        loading={submitLoading}
        antdModalProps={{ closable: false, mask: false }}
      >
        <DeleteConfirmationMessage>
          Are you sure you want to delete?
        </DeleteConfirmationMessage>
      </ConfirmationModal>
    </>
  );
};

export default AddKeyToPhraseForm;
